<template>
  <loading-overlay v-if="isLoading"></loading-overlay>
  <div v-else>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
      <h1 id="top">Element: <small>{{ element.name }}</small></h1>
    </div>

    <div class="card">
      <table class="card-table table">
        <tbody>
        <tr>
          <th scope="col">ID</th>
          <td>{{ element.id }}</td>
        </tr>
        <tr>
          <th scope="col">Name</th>
          <td>{{ element.name }}</td>
        </tr>
        <tr>
          <th scope="col">Archived</th>
          <td>
            <div v-if="element.archived">
                <span class="badge badge-warning">
                  <font-awesome-icon icon="archive"/>
                  Archived
                </span>
            </div>
            <div v-else>
              <span class="badge badge-success">Not Archived</span>
            </div>
          </td>
        </tr>
        <tr v-if="element.asset_link">
          <th scope="col">Asset</th>
          <td>
            <img v-if="element.asset_type.toLowerCase().includes('image')" :src="element.asset_link" alt="Fake" />
            <video v-else-if="element.asset_type.toLowerCase().includes('video')" controls>
              <source :src="element.asset_link" type="video/mp4">
            </video>
          </td>
        </tr>
        <tr>
          <th scope="col">Created At</th>
          <td>{{ new Date(element.created_at).toDateString() }}, {{ new Date(element.created_at).toLocaleTimeString() }}</td>
        </tr>
        <tr>
          <th scope="col">Updated At</th>
          <td>{{ new Date(element.updated_at).toDateString() }}, {{ new Date(element.created_at).toLocaleTimeString() }}</td>
        </tr>
        </tbody>
      </table>
      <div class="card-footer">
        <div class="btn-group">
          <router-link :to="{ name: 'ElementIndex', params: { kioskId: kioskId, componentId: componentId } }" tag="button" class="btn btn-secondary">Back</router-link>
          <router-link :to="{ name: 'ComponentShow', params: { kioskId: kioskId, id: componentId } }" tag="button" class="btn btn-secondary">Component {{componentId}}</router-link>
          <router-link v-if="isAdmin || (isEditor && isKioskAdmin)" :to="{ name: 'ElementEdit', params: { kioskId: kioskId, componentId: componentId, id: element.id } }" tag="button" class="btn btn-primary">Edit</router-link>
          <button v-if="isAdmin" v-on:click="$refs.elementDeleteModal.show()" type="button" class="btn btn-danger">Delete</button>
        </div>
      </div>
    </div>

    <b-modal ref="elementDeleteModal" header-bg-variant="danger" header-text-variant="light" class="elementDeleteModal" title="Confirm Delete" ok-variant="danger" ok-title="Delete" @ok="deleteElement" v-bind:ok-disabled="mollyGuard !== element.title">
      <p>Are you sure you want to delete <span class="font-weight-bold">{{ element.title }}</span>?</p>
      <p>To confirm the deletion of this element, enter the title of the element below:</p>
      <form @submit.stop.prevent autocomplete="off">
        <div class="form-group">
          <input type="text" class="form-control" v-model="mollyGuard" placeholder="Element Title"/>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { ElementService } from '@/common/services/element.service';
import LoadingOverlay from '@/common/components/loading-overlay.vue';
import permissionsMixin from '@/mixins/permissions-mixin';
import PermissionsService from '@/common/services/user_permissions.service';

export default {
  name: 'ElementShow',
  mixins: [permissionsMixin],
  components: {
    LoadingOverlay,
  },
  data() {
    return {
      element: null,
      kioskId: null,
      componentId: null,
      isLoading: true,
      totalRows: 0,
      mollyGuard: null,
    };
  },
  created() {
    this.kioskId = this.$route.params.kioskId;
    this.componentId = this.$route.params.componentId;
    this.isAdmin = PermissionsService.isAdmin();
    if (this.isAdmin === false) {
      this.$router.push({ name: 'KioskShow', params: { id: this.kioskId } });
    } else {
      this.getElement();
    }
  },
  methods: {
    getElement() {
      ElementService.get(this.kioskId, this.componentId, this.$route.params.id)
        .then((response) => {
          this.element = response.data;
          this.isLoading = false;
        })
        .catch(err => console.error(err));
    },
    deleteElement() {
      ElementService.destroy(this.kioskId, this.$route.params.id)
        .then((response) => {
          this.$router.push({ name: 'ElementIndex' });
          this.$notify({
            title: `Deleted ${response.data.name}`,
            text: 'Successfully deleted element.',
            type: 'success',
            width: 350,
          });
        });
    },
  },
  beforeRouteUpdate(to, from, next) {
    ElementService.get(to.params.id)
      .then((response) => {
        this.element = response.data;
        this.isLoading = false;
      })
      .then(() => {
        next();
      })
      .catch(err => console.error(err));
  },
};
</script>

<style lang="scss" scoped>
</style>
